import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Typography, Grid, Modal } from '@mui/material';
import { ReactComponent as ClearIcon } from 'assets/images/svg/clear.svg';

const ConfirmModal = forwardRef(({ 
    title, 
    message, 
    onAccept, 
    validLabel, 
    ignoreLabel, 
    onClose 
}, ref) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const acceptLabel = t("buttons.valid");
    const refuseLabel = onAccept ? t("buttons.reject") : t("buttons.close");

    // Open and close modal
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose();
    };

    // Expose open/close methods to parent component
    useImperativeHandle(ref, () => ({
        handleOpen,
        handleClose
    }));

    // Handle acceptance
    const handleAccept = () => {
        setOpen(false);
        if (onAccept) onAccept();
    };

    return (
        <Modal 
            open={open} 
            onClose={handleClose} 
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <div className="modal_wrapper modal_confirm">
                <div className="modal_message">
                    {/* Title and close button */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="h6">{title}</Typography>
                        <IconButton
                            edge="start"
                            color="primary"
                            onClick={handleClose}
                            aria-label="Fermer"
                            sx={{ position: 'absolute', top: 0, right: 0 }}
                        >
                            <ClearIcon className="primary_color" height={20} width={20} />
                        </IconButton>
                    </Box>

                    {/* Message */}
                    <Typography 
                        sx={{ mt: 2, maxHeight: '60vh', overflow: 'auto' }} 
                        dangerouslySetInnerHTML={{ __html: message }} 
                    />
                </div>

                {/* Bottom buttons */}
                <Grid container>
                    <Grid 
                        item xs={onAccept ? 6 : 12} 
                        className="modal_bottom_button" 
                        onClick={handleClose}
                    >
                        {ignoreLabel || refuseLabel}
                    </Grid>

                    {onAccept && (
                        <Grid 
                            item xs={6} 
                            className="modal_bottom_button modal_bottom_button_green" 
                            onClick={handleAccept}
                        >
                            {validLabel || acceptLabel}
                        </Grid>
                    )}
                </Grid>
            </div>
        </Modal>
    );
});

export default ConfirmModal;
